module.exports = __webpack_public_path__ + "static/media/bunu_thinking.e85c736a.gif";